"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rest_api_1 = require("@nimles/rest-api");

var actionTypes_1 = require("../actionTypes");

var actionCreator_1 = require("../../utils/actionCreator");

exports.loadPublicProductStocks = function (queryParameters) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.LOAD_PUBLIC_PRODUCTSTOCKS
  }, function (_a) {
    var auth = _a.auth;
    return rest_api_1.getPublicProductStocks(auth, queryParameters);
  });
};

exports.loadPublicProductStock = function (id) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.LOAD_PUBLIC_PRODUCTSTOCK,
    id: id
  }, function (_a) {
    var auth = _a.auth;
    return rest_api_1.getPublicProductStock(auth, id);
  });
};